module.exports = __webpack_public_path__ + "img/enfg-checkpoint-model-selector.8e281dd4.png";